import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.3335 1.33325H5.3335V2.33325H1.3335V4.33325H2.8335L3.3335 15.3333H13.2426L13.8335 4.33325H15.3335V2.33325H11.3335V1.33325ZM5.3335 5.33325H6.3335V13.3333H5.3335V5.33325ZM7.8335 5.33325H8.8335V13.3333H7.8335V5.33325ZM10.3335 5.33325H11.3335V13.3333H10.3335V5.33325Z",
		fill: "currentColor"
	})]
});
export default SvgTrash;
